<template>
  <div>
    <div class="nx_banner"></div>
    <!--课程介绍菜单-->
    <div class="wrap box nx_content">
      <ul class="tabs">
        <li class="tab1_1"><a href="#" name=".tab1_3">被动学习</a></li>
        <li class="tab1_2"><a href="#" name=".tab1_4">主动学习</a></li>
      </ul>
      <div class="tab_content">
        <!--被动学习-->
        <div class="tab1_3 w1200 wrap bd_edu_con">
          <dl class="color_a">
            <dt><img src="@/assets/images/edu_icon_a.png" width="76" height="76" /></dt>
            <dd>
              <h3>报名</h3>
              <p>学员在线报名填写报名信息，方便快捷。时间自由掌控，课程自由选择。</p>
            </dd>
          </dl>

          <dl class="color_b">
            <dt><img src="@/assets/images/edu_icon_b.png" width="76" height="76" /></dt>
            <dd>
              <h3>培训计划</h3>
              <p>定制专属课程培训计划，课程学习课时内容自由选择，个性化定制。学员自由选择学习时间，更加合理，所学即所需。</p>
            </dd>
          </dl>

          <dl class="color_c">
            <dt><img src="@/assets/images/edu_icon_h.png" width="76" height="76" /></dt>
            <dd>
              <h3>考核</h3>
              <p>定制专属课程培训计划，课程学习课时内容自由选择，个性化定制。学员自由选择学习时间，更加合理，所学即所需。</p>
            </dd>
          </dl>

          <dl class="color_d">
            <dt><img src="@/assets/images/edu_icon_i.png" width="76" height="76" /></dt>
            <dd>
              <h3>学习</h3>
              <p>学员在线学习，讲师面对面指导教学。学习时间自由掌控，课程自由选择。课程结束后可重新学习机会。</p>
            </dd>
          </dl>
        </div>
        <!--/被动学习-->
        <!--主动学习-->
        <div class="tab1_4 w1200 wrap edu_con">
          <dl class="color_a">
            <dt><img src="@/assets/images/edu_icon_c.png" width="76" height="76" /></dt>
            <dd>
              <h3>报名</h3>
              <p>学员在线报名填写报名信息，方便快捷。时间自由掌控，课程自由选择。</p>
            </dd>
          </dl>

          <dl class="color_b">
            <dt><img src="@/assets/images/edu_icon_g.png" width="76" height="76" /></dt>
            <dd>
              <h3>考试</h3>
              <p>学员在线学习，讲师面对面指导教学。学习时间自由掌控，课程自由选择。课程结束后可重新学习机会。</p>
            </dd>
          </dl>

          <dl class="color_c">
            <dt><img src="@/assets/images/edu_icon_j.png" width="76" height="76" /></dt>
            <dd>
              <h3>问卷</h3>
              <p>定制专属课程培训计划，课程学习课时内容自由选择，个性化定制。学员自由选择学习时间，更加合理，所学即所需。</p>
            </dd>
          </dl>
        </div>
        <!--/主动学习-->
      </div>
      <!--/课程介绍菜单-->
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import {init} from '@/assets/js/public'
export default {
  components: { },
  data () {
    return {
    }
  },
  computed: {},
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      init()
    })
  },
  destroyed () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/training.vue